import { clsx } from "clsx";
import type { TocHeading } from "@/components/kit/KitMarkdown/toc";
import { toTrackSlug } from "@/utils/track-slug";

export interface BlogTableOfContentsProps {
  headings: TocHeading[];
  className?: string;
}

/**
 * «Содержание» — anchor links to the article's H2/H3 headings, ids matching the
 * rendered body (both come from `extractTocHeadings` / `createHeadingId`).
 * Rendered in the sticky desktop right rail and inline on mobile.
 */
export function BlogTableOfContents({ headings, className }: BlogTableOfContentsProps) {
  if (headings.length < 2) return null;

  return (
    <nav
      aria-label="Содержание"
      className={clsx("blog-toc", className)}
      data-component="BlogTableOfContents"
    >
      <p className="blog-toc-title">Содержание</p>
      <ol className="blog-toc-list">
        {headings.map((heading) => (
          <li key={heading.id} className={clsx(heading.depth === 3 && "blog-toc-sub")}>
            <a
              href={`#${heading.id}`}
              data-track={`blog-article.toc.${toTrackSlug(heading.text, heading.id)}`}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

BlogTableOfContents.displayName = "BlogTableOfContents";
